import VueRouter from 'vue-router';
import { auth } from './firebase';

import Login from '../components/login.vue';
import Home from '../components/home/home.vue';
import Colaboradores from '../components/colaboradores.vue';
import Colaborador from '../components/colaborador/colaborador.vue';

const router = new VueRouter({
  routes:
  [{
    path: '/login',
    name: 'login',
    component: Login
  },
  {
    path: '/',
    name: 'home',
    component: Home,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/colaboradores',
    name: 'colaboradores',
    component: Colaboradores,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/colaborador/:user',
    name: 'colaborador',
    component: Colaborador,
    meta: {
      requiresAuth: true
    }
  }
  ]
});

// Check before each page load whether the page requires authentication/
// if it does check whether the user is signed into the web app or
// redirect to the sign-in page to enable them to sign-in
router.beforeEach((to, from, next) => {
  const currentUser = auth.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if (requiresAuth && !currentUser) next('/login');
  else if (requiresAuth && currentUser) next();
  else next();
});

export default router;
